'use strict';

const { queryFirst } = require('../domUtil');
const { NOT_AVAILABLE_STATUS, PREORDER_STATUS } = require('../constants');
const { productEDDData } = window.lillyUtils;
const isEDDEnabled = !!productEDDData;

const EDD_INFO_SELECTOR = '.narvar-edd-info';
const EDD_PROMOMESSAGE_SELECTOR = '.promo-edd-info';

/**
 * Function to inject Estimated delivery date message into its container
 * @param {HTMLElement} productContainerEl - Product container element
 */
function injectEDDInfo(productContainerEl) {
    if (!isEDDEnabled || !productContainerEl) return;

    const { pid, masterid } = productContainerEl.dataset;
    const eddEl = queryFirst(EDD_INFO_SELECTOR, productContainerEl);
    const eddData = productEDDData[pid] || productEDDData[masterid];
    if (!eddData || Object.keys(eddData).length === 0) return;
    if (eddEl) eddEl.innerHTML = eddData.estimatedDeliveryTime;

    const freeShippingPromo = queryFirst(EDD_PROMOMESSAGE_SELECTOR, productContainerEl);
    if (freeShippingPromo && eddData.eddShortMessage) {
        freeShippingPromo.innerHTML = eddData.eddShortMessage;
    }
}

/**
 * Function to remove Estimated delivery date message from its container
 * @param {HTMLElement} productContainerEl - Product container element
 */
function removeEDDInfo(productContainerEl) {
    if (!isEDDEnabled || !productContainerEl) return;

    const eddEl = queryFirst(EDD_INFO_SELECTOR, productContainerEl);
    if (eddEl) eddEl.textContent = '';

    const freeShippingPromo = queryFirst(EDD_PROMOMESSAGE_SELECTOR, productContainerEl);
    if (freeShippingPromo) {
        freeShippingPromo.innerHTML = '';
    }
}

/**
 * Function to check if Estimated delivery messages to be displayed or not for that variant
 * @param {string} availabilityStatus - Product container element
 * @return {boolean} - if EDD is applicable for a variant, it returns true, else returns false
 */
function isEDDApplicable(availabilityStatus) {
    return (availabilityStatus !== PREORDER_STATUS && availabilityStatus !== NOT_AVAILABLE_STATUS);
}

module.exports = {
    isEDDApplicable,
    injectEDDInfo,
    removeEDDInfo
};
